import { render, staticRenderFns } from "./MessageBar.vue?vue&type=template&id=280287ca&scoped=true"
import script from "./MessageBar.vue?vue&type=script&lang=js"
export * from "./MessageBar.vue?vue&type=script&lang=js"
import style0 from "./MessageBar.vue?vue&type=style&index=0&id=280287ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280287ca",
  null
  
)

export default component.exports